import React from 'react';

export const HamburgerIcon = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="relative w-10 h-10 flex flex-col items-center justify-center gap-1.5 z-50"
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      id="mobile-menu-button"
    >
      <span
        id="hamburger-top"
        className={`w-6 h-0.5 bg-current transition-all duration-300 ease-in-out ${
          isOpen ? 'rotate-45 translate-y-2' : ''
        }`}
      />
      <span
        id="hamburger-middle"
        className={`w-6 h-0.5 bg-current transition-all duration-300 ease-in-out ${
          isOpen ? 'opacity-0' : 'opacity-100'
        }`}
      />
      <span
        id="hamburger-bottom"
        className={`w-6 h-0.5 bg-current transition-all duration-300 ease-in-out ${
          isOpen ? '-rotate-45 -translate-y-2' : ''
        }`}
      />
    </button>
  );
};